import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpClient, HttpBackend, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateLoaderStatic } from './i18n';
import { environment } from '@env';
import { ShellUserModule, ShellSalesModule, ShellAuthModule } from './shells';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CoreModule } from '@corelabs/angular-core';
import { AppComponent } from './app.component';
import { HttpCoreService } from './core/services/http.service';
import { MessagesModule } from './modules/messages';
// Stores
import { UserStoreModule } from './store/user';
import { LoadersStoreModule } from './store/loader';
import { ShippingAddressesStoreModule } from '@app/store/shipping-addresses';
import { ShoppingCartStoreModule } from './store/shopping-cart';
import { ProductDiscountsStoreModule } from '@app/store/product-discounts';
import { ProductSubstitutesStoreModule } from './store/product-substitutes';
import { ProductPricingStoreModule } from './store/product-pricing';
import { FavouritesStoreModule } from './store/favourites';
import { ConcessionsStoreModule } from './store/concessions';
import { PushNotificationsStoreModule } from './store/push-notifications';
import { AccountModule } from '@corelabs/angular-account';
import { MobileMenuModule } from './mobile-menu/mobile-menu.module';
import { constants } from '@const';
import { UpdateVersionComponent } from './shared/components/update-version-popup/components/update-version.component';

import { FileSaveNativeService, FileSaveService } from './shared/services';
import { Capacitor } from '@capacitor/core';

const isNativePlatform = Capacitor.isNativePlatform();

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        UpdateVersionComponent,
        BrowserModule,
        BrowserAnimationsModule,
        UserStoreModule,
        LoadersStoreModule,
        MessagesModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: () => {
                    return new TranslateLoaderStatic();
                },
                deps: [HttpBackend],
            },
        }),
        StoreModule.forRoot({}, {}),
        EffectsModule.forRoot([]),
        StoreDevtoolsModule.instrument({
            // Devtools mmust be imported after StoreModule
            serialize: true,
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true,
        }),
        ShippingAddressesStoreModule,
        ShellAuthModule,
        ShellUserModule,
        ShellSalesModule,
        AppRoutingModule,
        ConcessionsStoreModule,
        ShoppingCartStoreModule,
        ProductDiscountsStoreModule,
        ProductSubstitutesStoreModule,
        ProductPricingStoreModule,
        FavouritesStoreModule,
        MobileMenuModule,
        PushNotificationsStoreModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
        CoreModule.forRoot({ serverUrl: environment.serverUrl }),
        AccountModule.forRoot(constants.alerts),
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HttpClient,
            useClass: HttpCoreService,
        },
        isNativePlatform
            ? {
                  provide: FileSaveService,
                  useClass: FileSaveNativeService,
              }
            : FileSaveService,
    ],
})
export class AppModule {}
